
  import {
    Component,
    Vue
  } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    getTeamEarningsList
  } from '@/api/statistic'

  @Component({
    name: 'member-team',
    components: {
      PageFooter
    }
  })
  export default class MemberTeam extends Vue {
    private defaultAvatar = 'https://cdn2024.routuan.com/routuan/image/20230110-0f54988a-9589-45bc-ad27-844c60e80f36.png'
    private list: any = []
    private nameKey = '';
    private phoneKey = '';
    private pageNo = 1;
    private pageSize = 10;
    private total = 0;

    private mounted() {
      this.getList()
    }

    private changePage(num: number) {
      this.pageNo = num;
      this.getList();
    }

    private doSearch() {
      this.pageNo = 1;
      this.getList();
    }

    private clearSearch() {
      this.phoneKey = '';
      this.nameKey = ''
      this.pageNo = 1;
      this.getList();
    }

    private async getList() {
      let params: any = {
        page_no: this.pageNo,
        page_size: this.pageSize,
      }
      if (this.nameKey) {
        params.name = this.nameKey
      }
      if (this.phoneKey) {
        params.phone = this.phoneKey
      }
      try{
        const res: any = await getTeamEarningsList(params);
        this.list = res.info || []
        this.total = res.count;
      } catch (e) {
        console.log(e)
      }
    }
  }
